var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 4.32812C19.7656 4.67969 20 5.1875 20 5.65625V18.6641C20 19.6797 19.1406 20.5 18.0859 20.5H6.83594C5.82031 20.5 5 19.6797 5 18.6641V14.6016H6.83594V18.6641H18.125V7.41406H14.0234C13.5156 7.41406 13.0859 6.98438 13.0859 6.47656V2.41406H6.83594V10.8516H11.25V8.9375C11.25 8.50781 11.7188 8.3125 12.0312 8.58594L14.8438 11.4375C15.0391 11.6328 15.0391 11.9453 14.8438 12.1406L12.0312 14.9531C11.7188 15.2266 11.25 15.0312 11.25 14.6016V12.7266H0.46875C0.195312 12.7266 0 12.4922 0 12.2578V11.3203C0 11.0469 0.195312 10.8516 0.46875 10.8516H5V2.41406C5 1.35938 5.82031 0.539062 6.83594 0.5H14.8438C15.3125 0.5 15.7812 0.734375 16.1328 1.08594L19.4141 4.32812ZM14.9609 5.53906H17.9688L14.9609 2.53125V5.53906Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillForm);
export default __webpack_public_path__ + "static/media/fill-form.2db659b2700c20b8eee9025e684e5a73.svg";
export { ForwardRef as ReactComponent };